<template>
    <div v-if="config">
        <setting-card
            v-bind="binds"
            :settingBtnTitle="'Ajouter des crédits'"
            :dialogBind="dialogBind"
            @updateProfile="updateProfile()"
            :hideMoreVert="true"
            :hidePrevious="true"
        >
            <Pay :companyId="companyId" inPaymentType="PAYMENT_CREDIT" :actions="payActions" />
        </setting-card>
    </div>
</template>

<script lang="ts">
import settingCard from "../SettingCard.vue";

const BobbeeImg = require("../../../assets/img/bobbee_mini.png");

import Pay from "../../pay/Pay.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        Pay,
        settingCard,
    },
    emits: ["updateProfile"],
})
export class SettingPayment extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) payActions: string;

    get binds() {
        return {
            title: "Achat de crédits de paiement",
            partnerName: "bobbee",
            text: `Achetez des crédits pour payer avec bobbee. Vous avez ${
                this.config?.paymentCreditCount || 0
            } crédit(s) de paiement bobbee.`,
            // logo: BobbeeImg
        };
    }

    get dialogBind() {
        return {
            title: "Achat de crédits de paiement",
            "valid-title": "Ajouter des crédits",
        };
    }

    updateProfile() {
        this.$emit("updateProfile");
    }
}

export default toNative(SettingPayment);
</script>
